import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getDayRangeDates, setDateDifference } from 'utils/date-functions';

import AthletesAtRiskPageHeader from './components/AthletesAtRiskPageHeader';
import AthletesAtRiskTable from './components/AthletesAtRiskTable';
import { SearchFilters } from './types';

const AthletesAtRisk = (): JSX.Element => {
  const [, todayEnd] = getDayRangeDates();

  const initialSearchFiltersValue: SearchFilters = {
    date: setDateDifference(todayEnd, 0, 0, 14),
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('lastPackageEndDate');

  return (
    <>
      <AthletesAtRiskPageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <AthletesAtRiskTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default AthletesAtRisk;
